import axios from "axios"

export const BASE_DOMAIN = process.env.REACT_APP_BASE_DOMAIN
export const WEBPORTAL_URL = process.env.REACT_APP_BASE_WEB_URL

export const BASE_URL = `${BASE_DOMAIN}/ether/cms/api/v1`

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json"}
})
